import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import * as state from '@/components/Analysis/state';

export const useGetDetailsData = (assemblyDetails: Record<string, string> | undefined) => {
  const assemblyTemplate = useAtomValue(state.assemblyTemplate);

  const reviewSections = useMemo(() => {
    const reviewPanelConfig = assemblyTemplate?.reviewPanelConfig ?? [];
    if (!assemblyDetails || !reviewPanelConfig) return [];

    const allFields = assemblyTemplate?.fields ?? [];

    const displayableKeys = new Set(
      allFields.filter((f) => f?.displayInReview ?? false).map((f) => f.key)
    );
    const displayableEntries = Object.entries(assemblyDetails).filter(([key]) =>
      displayableKeys.has(key)
    );

    const pair = (k: string, v: string | number): [string, string | number] => [k, v];

    return reviewPanelConfig.map((group) => {
      const sections = (group.groupSection ?? [])
        .map((section) => {
          const keys =
            Array.isArray(section?.fieldKeys) && section.fieldKeys.length
              ? section.fieldKeys
              : displayableEntries.map(([k]) => k);

          const data = keys.reduce<[string, string | number][]>((accumulator, key) => {
            if (
              key &&
              displayableKeys.has(key) &&
              Object.prototype.hasOwnProperty.call(assemblyDetails, key)
            ) {
              const value = assemblyDetails[key];
              if (typeof value === 'string' || typeof value === 'number') {
                accumulator.push(pair(key, value));
              }
            }
            return accumulator;
          }, []);

          return { title: section?.title ?? '', data };
        })
        .filter((s) => s.data.length > 0);

      return { groupName: group.groupName ?? '', sections };
    });
  }, [assemblyDetails, assemblyTemplate?.fields, assemblyTemplate?.reviewPanelConfig]);

  return { reviewSections };
};
